var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.825 3.436c.857.23 1.532.906 1.763 1.763.428 1.565.412 4.827.412 4.827s0 3.245-.412 4.81a2.506 2.506 0 0 1-1.763 1.763c-1.565.412-7.825.412-7.825.412s-6.244 0-7.825-.428A2.506 2.506 0 0 1 .412 14.82C0 13.27 0 10.01 0 10.01s0-3.246.412-4.811a2.557 2.557 0 0 1 1.763-1.78C3.74 3.009 10 3.009 10 3.009s6.26 0 7.825.428Zm-4.613 6.574-5.205 2.998V7.011l5.205 2.999Z","fill":"currentColor"}));
}

Youtube.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
